import { render, staticRenderFns } from "./SithMesStoolPrApplicationShippingDetailEdit.vue?vue&type=template&id=4f4c8b46&"
import script from "./SithMesStoolPrApplicationShippingDetailEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPrApplicationShippingDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports